// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3cay_","header":"PatientQuestionnaire_header__3h9oQ","info":"PatientQuestionnaire_info__38ANq"};